import { RouterProvider } from 'react-router-dom';

// project-imports
import router from 'routes';
import { Provider } from 'react-redux';
import { persistor, store } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { GlobalModal } from './views/components/GlobalModel';
import "./config/i18n"
import { GlobalAlert } from './views/components/globalAlert/GlobalAlert';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GlobalLoader from './views/components/loader/GlobalLoader';
// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

function App() {
  return (
    <>
      <Provider store={store}>
        {/* loading={<Loader />}  */}
        <GlobalLoader />
        <PersistGate persistor={persistor}>
          <RouterProvider router={router} />
          <GlobalModal />
          <ToastContainer position="top-right" autoClose={3000} />
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
